// extracted by mini-css-extract-plugin
module.exports =  {"spinner-container":"_32bbee5fda--spinner-container--tvorZ"};